/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import Reveal from "./Reveal";
import { STEPS } from "./landing.data";

export default function StepsSection({ isArabic }) {
  return (
    <section className="gl-section" id="steps">
      <div className="gl-shell">
        <Reveal className="gl-head">
          <p className="gl-eyebrow">
            {isArabic ? "خطوات الاستخدام" : "How it works"}
          </p>
          <h2 className="gl-title">
            {isArabic ? "من الحساب إلى البيع في أربع خطوات" : "From signup to sales in four steps"}
          </h2>
          <p className="gl-lead">
            {isArabic
              ? "مسار واضح يوصلك من فكرة المتجر إلى استقبال الطلبات."
              : "A clear path from store idea to receiving orders."}
          </p>
        </Reveal>

        <div className="gl-steps">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <Reveal key={step.titleEn} delay={i * 0.08}>
                <article className="gl-step">
                  <span className="gl-step__num">0{i + 1}</span>
                  <div className="gl-step__icon">
                    <Icon size={24} strokeWidth={2} />
                  </div>
                  <h3 className="gl-step__title">
                    {isArabic ? step.titleAr : step.titleEn}
                  </h3>
                  <p className="gl-step__desc">
                    {isArabic ? step.descAr : step.descEn}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
